import React from 'react';
import '../App.css';
import { useTranslation } from 'react-i18next';

function DCF() {
  const { t } = useTranslation(); // 預設使用 translation namespace

  return (
    <div className="article-container">
      <h1>{t('dcf.title1')}</h1>
      <p dangerouslySetInnerHTML={{ __html: t('dcf.paragraph1') }} />

      <h3>{t('dcf.whyUseHeading')}</h3>
      <p>{t('dcf.paragraph2')}</p>
      <ul>
        <li>{t('dcf.bullet1')}</li>
        <li>{t('dcf.bullet2')}</li>
      </ul>

      <h3>{t('dcf.howWorksHeading')}</h3>
      <p>{t('dcf.paragraph3')}</p>
      <p>{t('dcf.basicIdea')}</p>
      <p>
        <strong>{t('dcf.formulaLabel')}</strong>
        <br />
        {t('dcf.formula')}
      </p>
      <p>
        <strong>{t('dcf.forExampleLabel')}</strong> {t('dcf.exampleParagraph')}
      </p>
      <p>{t('dcf.exampleConclusion')}</p>

      <h3>{t('dcf.whyImportantHeading')}</h3>
      <p>{t('dcf.paragraph4')}</p>
      <ul>
        <li>
          <strong>{t('dcf.subBullet1.label')}</strong>{' '}
          {t('dcf.subBullet1.text')}
        </li>
        <li>
          <strong>{t('dcf.subBullet2.label')}</strong>{' '}
          {t('dcf.subBullet2.text')}
        </li>
      </ul>

      <h3>{t('dcf.whenUseHeading')}</h3>
      <p>{t('dcf.paragraph5')}</p>

      <h1>{t('dcf.exampleLotteryTitle')}</h1>
      <p>{t('dcf.exampleLotteryParagraph1')}</p>
      <ol>
        <li>{t('dcf.exampleLotteryOption1')}</li>
        <li>{t('dcf.exampleLotteryOption2')}</li>
      </ol>
      <p
        dangerouslySetInnerHTML={{ __html: t('dcf.exampleLotteryParagraph2') }}
      />

      <h3>{t('dcf.step1Heading')}</h3>
      <p dangerouslySetInnerHTML={{ __html: t('dcf.step1Paragraph') }} />

      <h3>{t('dcf.step2Heading')}</h3>
      <p dangerouslySetInnerHTML={{ __html: t('dcf.step2Paragraph') }} />

      <h3>{t('dcf.step3Heading')}</h3>
      <p>{t('dcf.step3Paragraph1')}</p>
      <p>
        <strong>{t('dcf.dcfFormulaLabel')}</strong>
      </p>
      <p dangerouslySetInnerHTML={{ __html: t('dcf.step3Paragraph2') }} />

      <p>{t('dcf.step3Paragraph3')}</p>

      <h3>{t('dcf.step4Heading')}</h3>
      <p dangerouslySetInnerHTML={{ __html: t('dcf.step4Paragraph') }} />

      <h3>{t('dcf.finalThoughtHeading')}</h3>
      <p dangerouslySetInnerHTML={{ __html: t('dcf.finalThoughtParagraph') }} />

      <h1>{t('dcf.discountRateTitle')}</h1>
      <p>{t('dcf.discountRateParagraph1')}</p>
      <ul>
        <li>
          <strong>{t('dcf.discountRateList.inflation.label')}</strong>{' '}
          {t('dcf.discountRateList.inflation.text')}
        </li>
        <li>
          <strong>{t('dcf.discountRateList.growth.label')}</strong>{' '}
          {t('dcf.discountRateList.growth.text')}
        </li>
        <li>
          <strong>{t('dcf.discountRateList.opportunity.label')}</strong>{' '}
          {t('dcf.discountRateList.opportunity.text')}
        </li>
        <li>
          <strong>{t('dcf.discountRateList.riskFree.label')}</strong>{' '}
          {t('dcf.discountRateList.riskFree.text')}
        </li>
        <li>
          <strong>{t('dcf.discountRateList.market.label')}</strong>{' '}
          {t('dcf.discountRateList.market.text')}
        </li>
        <li>
          <strong>{t('dcf.discountRateList.personal.label')}</strong>{' '}
          {t('dcf.discountRateList.personal.text')}
        </li>
      </ul>
      <p>{t('dcf.discountRateParagraph2')}</p>
    </div>
  );
}

export default DCF;
